module.exports = __webpack_public_path__ + "img/woman.99e13987.webp";